import Vue from 'vue'
import Router from 'vue-router'
import auth from "@/auth/authService";
import { api } from './utils/requests';
import store from "./store/store"

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [

        {
            // =============================================================================
            // MAIN LAYOUT ROUTES
            // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [

                {
                    path: '/',
                    redirect: '/dashboard',
                    meta: {
                        rule: 'public'
                    }
                },
                {
                    path: '/dashboard',
                    name: 'dashboard-analytics',
                    component: () => import('./views/DashboardAnalytics.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/entity/list',
                    name: 'entity-list',
                    component: () => import('./views/entity/List.vue'),
                    meta: {
                        rule: 'subscriber',
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Entity' },
                            { title: 'List', active: true }
                        ],
                        pageTitle: "Entity List"
                    }
                },
                {
                    path: '/entity/add',
                    name: 'entity-new',
                    component: () => import('./views/entity/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Entity' },
                            { title: 'New', active: true }
                        ],
                        pageTitle: "Add Entity"
                    }
                },
                {
                    path: '/entity/:entity_id',
                    name: 'entity-edit',
                    component: () => import('./views/entity/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Entity' },
                            { title: 'Edit', active: true }
                        ],
                        pageTitle: "Edit Entity"
                    }
                },
                {
                    path: '/portfolio/list',
                    name: 'portfolio-list',
                    component: () => import('./views/portfolio/List.vue'),
                    meta: {
                        rule: 'subscriber',
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Portfolio' },
                            { title: 'List', active: true }
                        ],
                        pageTitle: "Portfolio List"
                    }
                },
                {
                    path: '/portfolio/add',
                    name: 'portfolio-new',
                    component: () => import('./views/portfolio/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Portfolio' },
                            { title: 'New', active: true }
                        ],
                        pageTitle: "Add Portfolio"
                    }
                },
                {
                    path: '/portfolio/:portfolio_id',
                    name: 'portfolio-edit',
                    component: () => import('./views/portfolio/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Portfolio' },
                            { title: 'Edit', active: true }
                        ],
                        pageTitle: "Edit Portfolio"
                    }
                },
                {
                    path: '/broker/list',
                    name: 'broker-list',
                    component: () => import('./views/broker/List.vue'),
                    meta: {
                        rule: 'subscriber',
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Broker' },
                            { title: 'List', active: true }
                        ],
                        pageTitle: "Broker List"
                    }
                },
                {
                    path: '/broker/add',
                    name: 'broker-new',
                    component: () => import('./views/broker/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Broker' },
                            { title: 'New', active: true }
                        ],
                        pageTitle: "Add Broker"
                    }
                },
                {
                    path: '/broker/:broker_id',
                    name: 'broker-edit',
                    component: () => import('./views/broker/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Broker' },
                            { title: 'Edit', active: true }
                        ],
                        pageTitle: "Edit Broker"
                    }
                },
                {
                    path: '/demat-account/list',
                    name: 'demat-account-list',
                    component: () => import('./views/demat-account/List.vue'),
                    meta: {
                        rule: 'subscriber',
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Demat Account' },
                            { title: 'List', active: true }
                        ],
                        pageTitle: "Demat Account List"
                    }
                },
                {
                    path: '/demat-account/add',
                    name: 'demat-account-new',
                    component: () => import('./views/demat-account/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Demat Account' },
                            { title: 'New', active: true }
                        ],
                        pageTitle: "Add Demat Account"
                    }
                },
                {
                    path: '/demat-account/:demat-account_id',
                    name: 'demat-account-edit',
                    component: () => import('./views/demat-account/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Demat Account' },
                            { title: 'Edit', active: true }
                        ],
                        pageTitle: "Edit Demat Account"
                    }
                },
                {
                    path: '/share/list',
                    name: 'share-list',
                    component: () => import('./views/share/List.vue'),
                    meta: {
                        rule: 'subscriber',
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Share' },
                            { title: 'List', active: true }
                        ],
                        pageTitle: "Share List"
                    }
                },
                {
                    path: '/share/add',
                    name: 'share-new',
                    component: () => import('./views/share/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Share' },
                            { title: 'New', active: true }
                        ],
                        pageTitle: "Add Share"
                    }
                },
                {
                    path: '/share/:share_id',
                    name: 'share-edit',
                    component: () => import('./views/share/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Share' },
                            { title: 'Edit', active: true }
                        ],
                        pageTitle: "Edit Share"
                    }
                },
                {
                    path: '/contract/list',
                    name: 'contract-list',
                    component: () => import('./views/contract/List.vue'),
                    meta: {
                        rule: 'subscriber',
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Contract' },
                            { title: 'List', active: true }
                        ],
                        pageTitle: "Contract List"
                    }
                },
                {
                    path: '/contract/add',
                    name: 'contract-new',
                    component: () => import('./views/contract/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Contract' },
                            { title: 'New', active: true }
                        ],
                        pageTitle: "Add Contract"
                    }
                },
                {
                    path: '/contract/:contract_id',
                    name: 'contract-edit',
                    component: () => import('./views/contract/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Contract' },
                            { title: 'Edit', active: true }
                        ],
                        pageTitle: "Edit Contract"
                    }
                },
                {
                    path: 'report/transaction-report',
                    name: 'transaction-report',
                    component: () => import('./views/report/TransactionReport.vue'),
                    meta: {
                        rule: 'subscriber'
                    },
                    pageTitle: "Transaction Report"
                },
                {
                    path: 'report/summary-report',
                    name: 'summary-report',
                    component: () => import('./views/report/SummaryReport.vue'),
                    meta: {
                        rule: 'subscriber'
                    },
                    pageTitle: "Summary Report"
                },
                // {
                //     path: 'report/scrip-fifo-report',
                //     name: 'scrip-fifo-report',
                //     component: () => import('./views/report/ScripFifoReport.vue'),
                //     meta: {
                //         rule: 'subscriber'
                //     },
                //     pageTitle: "Scrip FIFO Report"
                // },
                {
                    path: 'report/live-scrip-fifo-report',
                    name: 'live-scrip-fifo-report',
                    component: () => import('./views/report/LiveScripFifoReport.vue'),
                    meta: {
                        rule: 'subscriber'
                    },
                    pageTitle: "Live Scrip FIFO Report"
                },
                {
                    path: 'report/holding-report',
                    name: 'holding-report',
                    component: () => import('./views/report/HoldingReport.vue'),
                    meta: {
                        rule: 'subscriber'
                    },
                    pageTitle: "Holding Report"
                },
                {
                    path: 'report/capital-gain-report',
                    name: 'capital-gain-report',
                    component: () => import('./views/report/CapitalGainReport.vue'),
                    meta: {
                        rule: 'subscriber'
                    },
                    pageTitle: "Capital Gain Report"
                },
                {
                    path: '/reports/download',
                    name: 'reports-download',
                    component: () => import('./views/report/Exports.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                // corporate actions
                {
                    path: '/corporate-actions/bonus-action/new',
                    name: 'bonus-corporate-action',
                    component: () => import('./views/corporate-actions/BonusAction.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/corporate-actions/bonus-action/:bonus_id',
                    name: 'edit-bonus-corporate-action',
                    component: () => import('./views/corporate-actions/BonusAction.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/corporate-actions/split-action/new',
                    name: 'split-corporate-action',
                    component: () => import('./views/corporate-actions/SplitAction.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/corporate-actions/split-action/:split_id',
                    name: 'edit-split-corporate-action',
                    component: () => import('./views/corporate-actions/SplitAction.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/corporate-actions/merge-action/new',
                    name: 'merge-corporate-action',
                    component: () => import('./views/corporate-actions/MergerAction.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/corporate-actions/merge-action/:merge_id',
                    name: 'edit-merge-corporate-action',
                    component: () => import('./views/corporate-actions/MergerAction.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/corporate-actions/demerge-action/new',
                    name: 'demerge-corporate-action',
                    component: () => import('./views/corporate-actions/DemergeAction.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/corporate-actions/demerge-action/:demerge_id',
                    name: 'edit-demerge-corporate-action',
                    component: () => import('./views/corporate-actions/DemergeAction.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/corporate-actions/list',
                    name: 'corporate-action-list',
                    component: () => import('./views/corporate-actions/List.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                }
            ],
        },
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
                {
                    path: '/accounts/login',
                    name: 'page-login',
                    // redirect: api.base_auth_url + api.native_auth_urls.login,
                    component: () => import('@/views/pages/Login.vue'),
                    meta: {
                        rule: 'public'
                    }
                },
                {
                    path: '/accounts/register',
                    name: 'page-register',
                    component: () => import('@/views/pages/Register.vue'),
                    meta: {
                        rule: 'public'
                    }
                },
                {
                    path: '/accounts/logout',
                    name: 'page-logout',
                    component: () => import('@/views/pages/Logout.vue'),
                    meta: {
                        rule: 'subscriber'
                    }
                },
                {
                    path: '/accounts/forgot-password',
                    name: 'page-forgot-password',
                    component: () => import('@/views/pages/ForgotPassword.vue'),
                    meta: {
                        rule: 'public'
                    }
                },
                // {
                //     path: '/pages/comingsoon',
                //     name: 'page-coming-soon',
                //     component: () => import('@/views/pages/ComingSoon.vue'),
                //     meta: {
                //         rule: 'public'
                //     }
                // },
                {
                    path: '/errors/404',
                    name: 'page-error-404',
                    component: () => import('@/views/pages/Error404.vue'),
                    meta: {
                        rule: 'public'
                    }
                },
                {
                    path: '/errors/500',
                    name: 'page-error-500',
                    component: () => import('@/views/pages/Error500.vue'),
                    meta: {
                        rule: 'public'
                    }
                },
                {
                    path: '/errors/not-authorized',
                    name: 'page-not-authorized',
                    component: () => import('@/views/pages/NotAuthorized.vue'),
                    meta: {
                        rule: 'public'
                    }
                },
                {
                    path: '/errors/offline',
                    name: 'page-offline',
                    component: () => import('@/views/pages/Offline.vue'),
                    meta: {
                        rule: 'public'
                    }
                },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/errors/404'
        }
    ],
})

router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
    if (store.state.active_service_worker) {
        store.state.active_service_worker.update()
    }
})

router.beforeEach((to, from, next) => {
    // console.log("Accessing ", to.path, " and You're online? ", navigator.onLine)

    if (!navigator.onLine) {
        if (to.path != '/errors/offline') {
            // console.log("Redirected to offline")
            return next({ name: 'page-offline', params: { next: to.path } })
        }
        else
            return next()
    }

    if (to.meta.rule == 'admin' || to.meta.rule == 'subscriber') {
        auth.isAuthenticated().then((res) => {
            next()
        }, (err) => {
            console.log("Redirecting")
            api.login_native({ to: to.path })
        })
    }
    else {
        next()
    }
});

export default router
